<template>
  <div class="hotspot-container">
    <!-- 页面标题 -->
    <div class="page-header">
      <h1 class="page-title">待处理订单</h1>
      <div class="header-actions">
        <el-button type="primary" @click="refreshData" :loading="loading">
          <i class="el-icon-refresh"></i>
          刷新
        </el-button>
      </div>
    </div>

    <!-- 搜索筛选区域 -->
    <div class="search-section">
      <el-card>
        <div class="search-form">
          <div class="search-row">
            <div class="search-item" >
              <label>订单状态：</label>
              <el-select v-model="searchParams.status" placeholder="请选择状态" clearable>
                <el-option label="未导出" value="Noexported"></el-option>
                <el-option label="已导出" value="Exported"></el-option>
              </el-select>
            </div>
            <div class="search-item" >
              <label>订单类型：</label>
              <el-select v-model="searchParams.type" placeholder="请选择类型" clearable>
                <el-option label="超主点订单" value="regular"></el-option>
                <el-option label="散订单" value="fuxiangsan"></el-option>
                <el-option label="批量订单" value="bulk"></el-option>
              </el-select>
            </div>
            <div class="search-item" >
              <label>订单号：</label>
              <el-input 
                v-model="searchParams.orderNumber" 
                placeholder="请输入订单号" 
                clearable
                @keyup.enter="handleSearch">
              </el-input>
            </div>
            <div class="search-actions">
              <el-button type="primary" @click="handleSearch" :loading="loading">
                <i class="el-icon-search"></i>
                搜索
              </el-button>
              <el-button @click="resetSearch">
                <i class="el-icon-refresh-left"></i>
                重置
              </el-button>
            </div>
          </div>
        </div>
      </el-card>
    </div>

    <!-- 统计信息 -->
    <div class="stats-section">
      <el-row :gutter="20">
        <el-col :span="8">
          <el-card class="stats-card all">
            <div class="stats-content">
              <div class="stats-number">{{ totalRecords }}</div>
              <div class="stats-label">总记录数</div>
            </div>
            <i class="el-icon-document stats-icon"></i>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card class="stats-card pending">
            <div class="stats-content">
              <div class="stats-number">{{ pendingCount }}</div>
              <div class="stats-label">待处理</div>
            </div>
            <i class="el-icon-warning stats-icon"></i>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card class="stats-card processed">
            <div class="stats-content">
              <div class="stats-number">{{ processedCount }}</div>
              <div class="stats-label">已处理</div>
            </div>
            <i class="el-icon-check stats-icon"></i>
          </el-card>
        </el-col>
<!--        <el-col :span="6">-->
<!--          <el-card class="stats-card urgent">-->
<!--            <div class="stats-content">-->
<!--              <div class="stats-number">{{ urgentCount }}</div>-->
<!--              <div class="stats-label">紧急处理</div>-->
<!--            </div>-->
<!--            <i class="el-icon-warning-outline stats-icon"></i>-->
<!--          </el-card>-->
<!--        </el-col>-->
      </el-row>
    </div>

    <!-- 数据表格 -->
    <!-- 桌面端表格 -->
    <div class="table-section" v-show="!isMobile">
      <el-card>
        <el-table 
          :data="tableData" 
          v-loading="loading"
          stripe
          border
          style="width: 100%"
          :default-sort="{prop: 'createdAt', order: 'descending'}">
          
          <el-table-column prop="orderNumber" label="订单号" width="160" fixed="left">
            <template #default="scope">
              <el-tag :type="getOrderTypeTagType(scope.row.type)" size="small">
                {{ formatOrderType(scope.row.type) }}
              </el-tag>
              <div class="order-number">{{ scope.row.orderNumber }}</div>
            </template>
          </el-table-column>

          <el-table-column prop="status" label="状态" width="100">
            <template #default="scope">
              <el-tag :type="getStatusTagType(scope.row.status)" size="small">
                {{ formatStatus(scope.row.status) }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column prop="recipient" label="收件人" width="120">
            <template #default="scope">
              <div class="recipient-info">
                <div class="name">{{ scope.row.recipient }}</div>
                <div class="phone">{{ scope.row.phone }}</div>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="address" label="收货地址" min-width="200" show-overflow-tooltip>
          </el-table-column>

          <el-table-column prop="purchasingUnits" label="采购单位" width="250" show-overflow-tooltip>
          </el-table-column>

          <el-table-column prop="role" label="下单角色" width="100">
            <template #default="scope">
              <el-tag :type="scope.row.role === 'ADMIN' ? 'danger' : 'primary'" size="small">
                {{ scope.row.role === 'ADMIN' ? '管理员' : '用户' }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column prop="createdAt" label="创建时间" width="160" sortable>
            <template #default="scope">
              <div class="time-info">
                <div class="create-time">{{ formatDateTime(scope.row.createdAt) }}</div>
                <div class="time-ago" :class="getTimeAgoClass(scope.row.minutesFromCreation)">
                  {{ formatTimeAgo(scope.row.minutesFromCreation) }}
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="visible" label="冷静期" width="150" v-if="isAdmin">
            <template #default="scope">
              <el-tag :type="scope.row.visible ? 'success' : 'warning'" size="small">
                {{ scope.row.visible ? '度过冷静期' : '未度过冷静期' }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="120" fixed="right">
            <template #default="scope">
              <el-button 
                type="primary" 
                size="small" 
                @click="viewOrderDetail(scope.row)"
                :disabled="!scope.row.visible && isAdmin">
                查看详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination-wrapper">
          <el-pagination
            v-model:current-page="pagination.pageNum"
            v-model:page-size="pagination.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            :total="totalRecords"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 移动端卡片列表 -->
    <div class="mobile-cards" v-show="isMobile">
      <el-card v-for="row in tableData" :key="row.id || row.orderNumber" class="order-card" shadow="hover">
        <div class="card-header">
          <div class="left">
            <el-tag :type="getOrderTypeTagType(row.type)" size="small">{{ formatOrderType(row.type) }}</el-tag>
          </div>
          <div class="center">
            <div class="order-number">{{ row.orderNumber }}</div>
          </div>
          <div class="right">
            <el-tag :type="getStatusTagType(row.status)" size="small">{{ formatStatus(row.status) }}</el-tag>
          </div>
        </div>

        <div class="card-body">
          <p><strong>收件人：</strong>{{ row.recipient }}</p>
          <p><strong>联系电话：</strong>{{ row.phone }}</p>
          <p class="text-ellipsis"><strong>地址：</strong>
            <el-tooltip :content="row.address" placement="top" :disabled="!row.address || row.address.length <= 30">
              <span class="ellipsis-text">{{ row.address }}</span>
            </el-tooltip>
          </p>
          <p class="text-ellipsis"><strong>采购单位：</strong>
            <el-tooltip :content="row.purchasingUnits" placement="top" :disabled="!row.purchasingUnits || row.purchasingUnits.length <= 20">
              <span class="ellipsis-text">{{ row.purchasingUnits }}</span>
            </el-tooltip>
          </p>
          <p><strong>下单角色：</strong>
            <el-tag :type="row.role === 'ADMIN' ? 'danger' : 'primary'" size="small">
              {{ row.role === 'ADMIN' ? '管理员' : '用户' }}
            </el-tag>
          </p>
          <p><strong>创建时间：</strong>{{ formatDateTime(row.createdAt) }}</p>
        </div>

        <div class="card-actions">
          <el-button type="primary" size="small" @click="viewOrderDetail(row)" :disabled="!row.visible && isAdmin">查看详情</el-button>
        </div>
      </el-card>

      <!-- 移动端分页 -->
      <div class="pagination-wrapper">
        <el-pagination
          v-model:current-page="pagination.pageNum"
          v-model:page-size="pagination.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="totalRecords"
          layout="total, prev, pager, next"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>

    <!-- 订单详情弹窗 -->
    <el-dialog 
      v-model="detailDialogVisible" 
      title="订单详情" 
      :width="isMobile ? '95%' : '600px'"
      :close-on-click-modal="false"
      :fullscreen="isMobile"
      :show-close="true">
      <div v-if="selectedOrder" class="order-detail">
        <el-descriptions :column="isMobile ? 1 : 2" border>
          <el-descriptions-item label="订单号">{{ selectedOrder.orderNumber }}</el-descriptions-item>
          <el-descriptions-item label="订单类型">{{ formatOrderType(selectedOrder.type) }}</el-descriptions-item>
          <el-descriptions-item label="订单状态">
            <el-tag :type="getStatusTagType(selectedOrder.status)">
              {{ formatStatus(selectedOrder.status) }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="下单角色">
            <el-tag :type="selectedOrder.role === 'ADMIN' ? 'danger' : 'primary'">
              {{ selectedOrder.role === 'ADMIN' ? '管理员' : '用户' }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="收件人">{{ selectedOrder.recipient }}</el-descriptions-item>
          <el-descriptions-item label="联系电话">{{ selectedOrder.phone }}</el-descriptions-item>
          <el-descriptions-item label="收货地址" :span="2">{{ selectedOrder.address }}</el-descriptions-item>
          <el-descriptions-item label="采购单位" :span="2">{{ selectedOrder.purchasingUnits }}</el-descriptions-item>
          <el-descriptions-item label="创建时间">{{ formatDateTime(selectedOrder.createdAt) }}</el-descriptions-item>
          <el-descriptions-item label="距今时间">
            <span :class="getTimeAgoClass(selectedOrder.minutesFromCreation)">
              {{ formatTimeAgo(selectedOrder.minutesFromCreation) }}
            </span>
          </el-descriptions-item>
          <el-descriptions-item label="冷静期" v-if="isAdmin">
            <el-tag :type="selectedOrder.visible ? 'success' : 'warning'">
              {{ selectedOrder.visible ? '度过冷静期' : '未度过冷静期' }}
            </el-tag>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="detailDialogVisible = false">关闭</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted, onUnmounted, watch } from 'vue'
import { ElMessage } from 'element-plus'
import axios from 'axios'

// 响应式数据
const loading = ref(false)
// 检测移动端
const isMobile = ref(window.innerWidth <= 768)

const handleResize = () => {
  isMobile.value = window.innerWidth <= 768
}

window.addEventListener('resize', handleResize)

const tableData = ref([])
const totalRecords = ref(0)
const detailDialogVisible = ref(false)
const selectedOrder = ref(null)

// 搜索参数
const searchParams = reactive({
  status: '',
  type: '',
  orderNumber: ''
})

// 分页参数
const pagination = reactive({
  pageNum: 1,
  pageSize: 20
})

// 判断是否为管理员
const isAdmin = computed(() => {
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
  return userInfo.role === 'ADMIN'
})

// 统计数据
const pendingCount = computed(() => {
  return tableData.value.filter(item => item.status === 'Noexported').length
})

const processedCount = computed(() => {
  return tableData.value.filter(item => item.status === 'Exported').length
})

// const urgentCount = computed(() => {
//   return tableData.value.filter(item =>
//     item.status === 'Noexported' && item.minutesFromCreation > 1440 // 超过24小时
//   ).length
// })

// 获取数据
const fetchData = async () => {
  loading.value = true
  try {
    const token = localStorage.getItem('token')
    const endpoint = isAdmin.value ? '/api/v1/admin/hotspots' : '/api/v1/user/hotspots'
    
    const params = {
      pageNum: pagination.pageNum,
      pageSize: pagination.pageSize,
      ...searchParams
    }

    // 如果是普通用户，添加userId参数
    if (!isAdmin.value) {
      const userId = localStorage.getItem('userId')
      if (userId) {
        params.userId = userId
      }
    }

    // 过滤空值参数
    Object.keys(params).forEach(key => {
      if (params[key] === '' || params[key] === null || params[key] === undefined) {
        delete params[key]
      }
    })

    const response = await axios.get(endpoint, {
      params,
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })

    if (response.data.code === '200') {
      const data = response.data.data
      tableData.value = data.data || []
      totalRecords.value = data.totalRecords || 0
      // console.log("获取数据成功", data)
    } else {
      ElMessage.error(response.data.msg || '获取数据失败')
    }
  } catch (error) {
    console.error('获取热点数据失败:', error)
    ElMessage.error('获取数据失败，请检查网络连接')
  } finally {
    loading.value = false
  }
}

// 搜索
const handleSearch = () => {
  pagination.pageNum = 1
  fetchData()
}

// 重置搜索
const resetSearch = () => {
  Object.keys(searchParams).forEach(key => {
    searchParams[key] = ''
  })
  pagination.pageNum = 1
  fetchData()
}

// 刷新数据
const refreshData = () => {
  fetchData()
}

// 分页处理
const handleSizeChange = (val) => {
  pagination.pageSize = val
  pagination.pageNum = 1
  fetchData()
}

const handleCurrentChange = (val) => {
  pagination.pageNum = val
  fetchData()
}

// 查看订单详情
const viewOrderDetail = (row) => {
  selectedOrder.value = row
  detailDialogVisible.value = true
}

// 格式化函数
const formatOrderType = (type) => {
  const typeMap = {
    'regular': '超主点',
    'fuxiangsan': '散订单',
    'bulk': '批量订单'
  }
  return typeMap[type] || type
}

const formatStatus = (status) => {
  const statusMap = {
    'Noexported': '未导出',
    'Exported': '已导出'
  }
  return statusMap[status] || status
}

const formatDateTime = (dateTime) => {
  if (!dateTime) return '-'
  return new Date(dateTime).toLocaleString('zh-CN')
}

const formatTimeAgo = (minutes) => {
  if (!minutes) return '-'
  
  if (minutes < 60) {
    return `${minutes}分钟前`
  } else if (minutes < 1440) {
    const hours = Math.floor(minutes / 60)
    return `${hours}小时前`
  } else {
    const days = Math.floor(minutes / 1440)
    return `${days}天前`
  }
}

// 样式类名
const getOrderTypeTagType = (type) => {
  const typeMap = {
    'regular': 'primary',
    'fuxiangsan': 'success',
    'bulk': 'warning'
  }
  return typeMap[type] || 'info'
}

const getStatusTagType = (status) => {
  return status === 'Noexported' ? 'warning' : 'success'
}

const getTimeAgoClass = (minutes) => {
  if (!minutes) return ''
  if (minutes > 1440) return 'urgent' // 超过24小时
  if (minutes > 720) return 'warning' // 超过12小时
  return 'normal'
}

// 监听搜索参数变化
watch(searchParams, () => {
  // 可以添加防抖逻辑
}, { deep: true })

// 页面挂载时获取数据
onMounted(() => {
  fetchData()
})

// 在组件卸载时移除监听，避免内存泄漏
onUnmounted(() => {
  window.removeEventListener('resize', handleResize)
})
</script>

<style scoped>
.hotspot-container {
  padding: 20px;
  background-color: #f5f5f5;
  min-height: 100vh;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.page-title {
  font-size: 24px;
  font-weight: bold;
  color: #303133;
  margin: 0;
}

.header-actions {
  display: flex;
  gap: 10px;
}

.search-section {
  margin-bottom: 20px;
}

.search-form {
  padding: 10px;
}

.search-row {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

.search-item {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 250px;
}

.search-item label {
  white-space: nowrap;
  font-weight: 500;
  color: #606266;
}

.search-actions {
  display: flex;
  gap: 10px;
  margin-left: auto;
}

.stats-section {
  margin-bottom: 20px;
}

.stats-card {
  position: relative;
  overflow: hidden;
}

.stats-card.pending {
  border-left: 4px solid #e6a23c;
}

.stats-card.processed {
  border-left: 4px solid #67c23a;
}

.stats-card.all {
  border-left: 4px solid #1d88a8;
}

.stats-content {
  position: relative;
  z-index: 2;
}

.stats-number {
  font-size: 28px;
  font-weight: bold;
  color: #303133;
  line-height: 1;
}

.stats-label {
  font-size: 14px;
  color: #909399;
  margin-top: 5px;
}

.stats-icon {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 40px;
  color: #dcdfe6;
  z-index: 1;
}

.table-section {
  background: white;
  border-radius: 8px;
  overflow: hidden;
}

/* 移动端卡片列表样式 */
.mobile-cards .order-card {
  margin-bottom: 12px;
}

.order-card .card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
  gap: 8px;
}

.order-card .card-header .left {
  flex: 1;
  display: flex;
  justify-content: flex-start;
}

.order-card .card-header .center {
  flex: 3;
  display: flex;
  justify-content: center;
  min-width: 0;
}

.order-card .card-header .right {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}

.order-card .center .order-number {
  font-family: monospace;
  font-size: 14px;
  color: #606266;
  text-align: center;
  width: 100%;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.order-card .card-body p {
  margin: 4px 0;
  font-size: 13px;
  color: #303133;
}


.order-card .phone {
  font-size: 12px;
  color: #909399;
}

.order-card .card-actions {
  text-align: right;
  margin-top: 8px;
}

/* 文本省略号样式 */
.order-card .text-ellipsis {
  display: flex;
  align-items: flex-start;
  gap: 4px;
}

.order-card .ellipsis-text {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}

.order-number {
  font-family: monospace;
  font-size: 12px;
  color: #606266;
  margin-top: 2px;
}

.recipient-info .name {
  font-weight: 500;
  color: #303133;
}

.recipient-info .phone {
  font-size: 12px;
  color: #909399;
  margin-top: 2px;
}

.time-info .create-time {
  font-size: 13px;
  color: #303133;
}

.time-info .time-ago {
  font-size: 12px;
  margin-top: 2px;
}

.time-ago.normal {
  color: #67c23a;
}

.time-ago.warning {
  color: #e6a23c;
}

.time-ago.urgent {
  color: #f56c6c;
  font-weight: 500;
}

.pagination-wrapper {
  padding: 20px;
  text-align: right;
  border-top: 1px solid #ebeef5;
}

.order-detail {
  padding: 10px 0;
}

/* 425px以下：优化详情弹窗表格样式 */
@media screen and (max-width: 425px) {
  .order-detail :deep(.el-descriptions__label) {
    font-size: 12px !important;
    white-space: nowrap;
    padding: 8px 6px !important;
    width: 80px;
    min-width: 80px;
  }
  
  .order-detail :deep(.el-descriptions__content) {
    font-size: 12px !important;
    padding: 8px 6px !important;
    word-break: break-all;
    min-width: 0;
  }
  
  .order-detail :deep(.el-descriptions__cell) {
    vertical-align: top;
  }
  
  .order-detail :deep(.el-descriptions-item) {
    margin-bottom: 0;
  }
}

.mobile-cards {
  margin-top: 20px;
  background: white;
  border-radius: 8px;
  overflow: hidden;
}

.order-card {
  margin-bottom: 10px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease-in-out;
}

.order-card:hover {
  transform: translateY(-3px);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  background-color: #f5f7fa;
  border-bottom: 1px solid #ebeef5;
}

.card-header .left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.card-header .order-number {
  font-family: monospace;
  font-size: 14px;
  color: #303133;
}

.card-body {
  padding: 15px;
  font-size: 14px;
  color: #606266;
}

.card-body p {
  margin-bottom: 8px;
  line-height: 1.6;
}

.card-body strong {
  color: #303133;
  font-weight: 500;
}

.card-body .phone {
  font-size: 13px;
  color: #909399;
}

.card-body .address {
  color: #e6a23c;
  font-style: italic;
}

.card-actions {
  padding: 10px 15px;
  border-top: 1px solid #ebeef5;
  text-align: right;
}

.card-actions .el-button {
  padding: 8px 15px;
}

@media screen and (max-width: 1340px)  {
  .search-row {
    flex-wrap: wrap;
    flex-direction: column
  }

  .search-actions {
    flex-basis: 100%;
    margin-left: 0;
    margin-top: 10px;
    justify-content: center;
  }
}

/* 响应式设计 */
@media screen and (max-width: 768px) {
  .hotspot-container {
    padding: 10px;
  }
  
  .page-header {
    gap: 15px;
    align-items: stretch;
  }
  
  .search-row {
    font-size: small;
  }
  
  .search-item {
    width: 215px;
  }
  
  .search-actions {
    margin-left: 0;
    justify-content: center;
  }
  
  .stats-section .el-col {
    margin-bottom: 10px;
  }
}

/* 425px以下的响应式优化 */
@media screen and (max-width: 425px) {
  .order-card .order-number {
    font-size: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  }
}

/* 422px 以下：统计卡纵向排布 */
@media screen and (max-width: 422px) {
  .stats-section .el-col {
    flex: 0 0 100%;   /* 宽度 100% */
    max-width: 100%;
  }
}

@media screen and (max-width: 320px) {
  .page-title {
    font-size: 20px;
  }

  .search-item{
    width: 200px;
  }
  
  .stats-number {
    font-size: 24px;
  }
  
  .stats-icon {
    font-size: 30px;
  }
}
</style>